// Large SVG/rail payloads belong in IndexedDB, not localStorage's small quota.
export async function playgroundRecord(uid, value) {
  const db = await new Promise((resolve, reject) => {
    const request = indexedDB.open("embroidery-auto-playground", 1);
    request.onupgradeneeded = () => request.result.createObjectStore("runs");
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(
        "runs",
        value === undefined ? "readonly" : "readwrite"
      );
      const store = tx.objectStore("runs");
      const req =
        value === undefined
          ? store.get(uid)
          : value === null
            ? store.delete(uid)
            : store.put(value, uid);
      tx.oncomplete = () => resolve(value === undefined ? req.result : value);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () =>
        reject(tx.error || new Error("Could not save playground progress."));
    });
  } finally {
    db.close();
  }
}
